module.exports = __webpack_public_path__ + "static/media/NvphShadenet.809fa19b.webp";